export default "__VITE_ASSET__BKoOMBFZ__"